// Provider logo URL normalizer (2026-08-30).
//
// Uploaded logos routinely arrive with big transparent margins around
// a small mark (Amanda's 600×600 PNG has the artwork in the middle
// ~40% of the canvas), so a 38px tile showed a ~15px logo swimming in
// a dark square. For Cloudinary-hosted logos we insert a transform
// that TRIMS the transparent border and fits the result to the tile
// at 2× for retina; other hosts pass through untouched.
export function logoSrc(url, px = 52) {
  if (!url || typeof url !== 'string') return url;
  const m = url.match(/^(https?:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.*)$/);
  if (!m) return url;
  // Already transformed (contains a transform segment)? Leave it.
  if (/^(e_|c_|w_|h_)/.test(m[2])) return url;
  const size = Math.round(px * 2);
  return `${m[1]}e_trim/c_fit,w_${size},h_${size}/${m[2]}`;
}
